// Central data-testid registry for Motor iNKS
export const TID = {
  // Audience toggle
  audienceB2B: 'audience-toggle-b2b',
  audienceRetail: 'audience-toggle-retail',

  // Auth
  authEmailInput: 'auth-email-input',
  authRequestBtn: 'auth-request-code-btn',
  authCodeInput: 'auth-code-input',
  authVerifyBtn: 'auth-verify-code-btn',
  authLogoutBtn: 'auth-logout-btn',
  navSignIn: 'nav-sign-in',
  navDashboard: 'nav-dashboard',
  navAdmin: 'nav-admin',

  // Admin
  adminTab: (k) => `admin-tab-${k}`,
  adminPortfolioUrl: 'admin-portfolio-url',
  adminPortfolioCaption: 'admin-portfolio-caption',
  adminPortfolioSubmit: 'admin-portfolio-submit',
  adminPortfolioDelete: (id) => `admin-portfolio-delete-${id}`,
  adminJobRun: (id) => `admin-job-run-${id}`,
  adminJobsRefresh: 'admin-jobs-refresh',

  // Dashboard
  dashMonthlyMrr: 'dashboard-monthly-mrr',
  dashActiveCount: 'dashboard-active-count',
  dashYearlyMrr: 'dashboard-yearly-mrr',

  // Wrapulator bulk tier
  wrapBulkBadge: 'wrap-bulk-tier-badge',

  // Nav
  navLogo: 'nav-logo',
  navQuoteCta: 'nav-quote-cta',
  navGuildLink: 'nav-guild-link',
  navWrapulator: 'nav-wrapulator-link',
  navMembership: 'nav-membership-link',
  navPortfolio: 'nav-portfolio-link',

  // Hero
  heroPrimaryCta: 'hero-primary-cta',
  heroSecondaryCta: 'hero-secondary-cta',

  // Guild banner
  guildBannerCta: 'guild-banner-cta',

  // Wrapulator
  wrapPresetSelect: 'wrapulator-preset',
  wrapMaterialSelect: 'wrapulator-material',
  wrapCoverage: 'wrapulator-coverage',
  wrapFinish: 'wrapulator-finish',
  wrapLaborSlider: 'wrapulator-labor',
  wrapQuantity: 'wrapulator-quantity',
  wrapComplexity: 'wrapulator-complexity',
  wrapMargin: 'wrapulator-margin',
  wrapTierSelect: 'wrapulator-tier',
  wrapCalcBtn: 'wrapulator-calc-btn',
  wrapGrandTotal: 'wrapulator-grand-total',
  wrapUpgradeBtn: 'wrapulator-upgrade-btn',

  // Membership
  planCard: (id) => `plan-card-${id}`,
  planCtaMonthly: (id) => `plan-cta-monthly-${id}`,
  planCtaYearly: (id) => `plan-cta-yearly-${id}`,
  planBillToggle: 'plan-bill-toggle',

  // Quote form
  quoteFirstName: 'quote-first-name',
  quoteLastName: 'quote-last-name',
  quoteEmail: 'quote-email',
  quotePhone: 'quote-phone',
  quoteCompany: 'quote-company',
  quoteProject: 'quote-project-type',
  quoteYear: 'quote-year',
  quoteMake: 'quote-make',
  quoteModel: 'quote-model',
  quoteDetails: 'quote-details',
  quoteSubmit: 'quote-submit',

  // Installer signup
  installerName: 'installer-name',
  installerEmail: 'installer-email',
  installerCity: 'installer-city',
  installerState: 'installer-state',
  installerYears: 'installer-years',
  installerSubmit: 'installer-submit',

  // Footer
  footerPhone: 'footer-phone',
  footerEmail: 'footer-email',

  // Nav additions
  navRateCard: 'nav-rate-card-link',
  navPartners: 'nav-partners-link',

  // Rate card page
  rateSection: (id) => `rate-section-${id}`,
  rateRow: (code) => `rate-row-${code}`,
  ratePrintBtn: 'rate-print-btn',
  rateGateOpen: 'rate-gate-open',
  rateGateEmail: 'rate-gate-email',
  rateGateCompany: 'rate-gate-company',
  rateGateSubmit: 'rate-gate-submit',
  rateGateClose: 'rate-gate-close',

  // Aftercare
  aftercareCard: (id) => `aftercare-card-${id}`,
  aftercareCta: (id) => `aftercare-cta-${id}`,

  // How it works
  howStep: (n) => `how-step-${n}`,

  // Partner application
  partnerCompany: 'partner-company',
  partnerContact: 'partner-contact',
  partnerEmail: 'partner-email',
  partnerPhone: 'partner-phone',
  partnerBizType: 'partner-biz-type',
  partnerVolume: 'partner-monthly-volume',
  partnerCity: 'partner-city',
  partnerState: 'partner-state',
  partnerWebsite: 'partner-website',
  partnerNotes: 'partner-notes',
  partnerSubmit: 'partner-submit',

  // Wrapulator wholesale
  wrapModeRetail: 'wrap-mode-retail',
  wrapModeWholesale: 'wrap-mode-wholesale',
  wrapDifficulty: 'wrap-difficulty',
  wrapPrintCost: 'wrap-print-cost',
  wrapRetailPrice: 'wrap-retail-price',
  wrapLinearFt: 'wrap-linear-ft',
  wrapProfitMargin: 'wrap-profit-margin',
};
